import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Popup from "reactjs-popup";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import "./categoryComponent.css";
import Box from "@mui/material/Box";

const CategoryTable = ({ categories, onEdit, onDelete }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleDeleteClick = (category) => {
    setSelectedCategory(category);
  };

  const confirmDelete = () => {
    if (selectedCategory) {
      onDelete(selectedCategory.id);
      setSelectedCategory(null);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "icon",
      headerName: "Icon",
      width: 100,
      renderCell: (params) => (
        <img
          src={`${params.value}`}
          alt={params.row.category_name}
          width={30}
        />
      ),
    },
    { field: "category_name", headerName: "Category Name", width: 200 },
    {
      field: "is_home_listed",
      headerName: "Is Home Listed",
      width: 150,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="action-btn">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => onEdit(params.row)}
          >
            <EditIcon />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div>
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 650, sm: 1000, lg: 1350 },
            bgcolor: "background.paper",
          }}
        >
          <DataGrid
            rows={categories}
            columns={columns}
            disableSelectionOnClick
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
          />
        </Box>
      </div>
      {selectedCategory && (
        <Popup
          className="popup-container"
          contentStyle={{
            borderRadius: "20px",
            backgroundColor: "white",
          }}
          open={true}
          onClose={() => setSelectedCategory(null)}
          modal
          nested
        >
          {(close) => (
            <div className="delete-img-div">
              <h3 className="delete-img-heading">Are you sure?</h3>
              <p className="delete-img-p">Do you really want to delete?</p>
              <div className="delete-btn-div">
                <button
                  onClick={() => {
                    confirmDelete();
                    close();
                  }}
                >
                  Delete
                </button>
                <button onClick={close}>Cancel</button>
              </div>
            </div>
          )}
        </Popup>
      )}
    </>
  );
};

export default CategoryTable;
